import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

interface StoreInfo {
  storeName: string;
  address: string;
  phone: string;
  email: string;
}

interface ReceiptSettings {
  headerText: string;
  footerText: string;
  showLogo: boolean;
}

interface AppSettings {
  theme: 'light' | 'dark';
  currencyFormat: 'id-ID' | 'en-US';
}

interface ResilienceSettings {
  latencyMs: number;
  errorRate: number; // 0 to 1
}

interface SettingsState {
  storeInfo: StoreInfo;
  receipt: ReceiptSettings;
  app: AppSettings;
  resilience: ResilienceSettings;

  updateStoreInfo: (info: Partial<StoreInfo>) => void;
  updateReceipt: (receipt: Partial<ReceiptSettings>) => void;
  updateApp: (app: Partial<AppSettings>) => void;
  updateResilience: (resilience: Partial<ResilienceSettings>) => void;
}

export const useSettingsStore = create<SettingsState>()(
  devtools(
    persist(
      (set) => ({
        storeInfo: {
          storeName: '',
          address: '',
          phone: '',
          email: '',
        },
        receipt: {
          headerText: '',
          footerText: '',
          showLogo: true,
        },
        app: {
          theme: 'light',
          currencyFormat: 'id-ID',
        },
        resilience: {
          latencyMs: 0,
          errorRate: 0,
        },

        updateStoreInfo: (info) =>
          set(
            (state) => ({
              storeInfo: { ...state.storeInfo, ...info },
            }),
            false,
            'settings/updateStoreInfo'
          ),
        updateReceipt: (receipt) =>
          set(
            (state) => ({
              receipt: { ...state.receipt, ...receipt },
            }),
            false,
            'settings/updateReceipt'
          ),
        updateApp: (app) =>
          set(
            (state) => ({
              app: { ...state.app, ...app },
            }),
            false,
            'settings/updateApp'
          ),
        updateResilience: (resilience) =>
          set(
            (state) => ({
              resilience: { ...state.resilience, ...resilience },
            }),
            false,
            'settings/updateResilience'
          ),
      }),
      {
        name: 'settings-storage',
      }
    ),
    { name: 'SettingsStore' }
  )
);
